import { publicEvents } from '@/i18n/dictionaries/publicEvents';
import { useTranslation } from '@/i18n/useTranslation';
import type { EventRatingsProps } from '@/features/publicsite/types/events/EventRatingsProps';

/** What participants made of the event: the overall average, then the presentations'. */
export function EventRatings({ feedback }: EventRatingsProps) {
  const { t } = useTranslation(publicEvents);
  return (
    <>
      {/* Only when there is a rating to show. "Fără evaluări încă." was a line that told the
        visitor nothing and pushed the one thing they came here to press further down. */}
      {feedback && feedback.responses > 0 && (
        <p className="event-detail__ratings">
          <strong>{feedback.averageRating.toFixed(1)}</strong> / 5 · {feedback.responses}{' '}
          {t('ratingsSuffix')}
        </p>
      )}
      {/* Its own count, not a share of the one above: the presentation rating arrived after
        the overall one, so an event can have twenty ratings and three of these. */}
      {feedback && feedback.presentationResponses > 0 && (
        <p className="event-detail__ratings">
          {t('presentationRatings')}:{' '}
          <strong>{feedback.averagePresentationRating.toFixed(1)}</strong> / 5 ·{' '}
          {feedback.presentationResponses} {t('ratingsSuffix')}
        </p>
      )}
    </>
  );
}
